import React from 'react';
import './Footer.css';

const Footer = () => {
  const footerLinks = {
    products: ['Product A', 'Product B', 'Product C', 'Product D'],
    company: ['About Us', 'Careers', 'Contact', 'Blog'],
    resources: ['Documentation', 'Support', 'API', 'Guides'],
    legal: ['Privacy Policy', 'Terms of Service', 'Cookie Policy', 'Disclaimer']
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3 className="footer-logo">DESIGN OPS</h3>
            <p className="footer-description">
              Transforming business operations with innovative solutions and cutting-edge technology.
            </p>
            <div className="social-icons">
              <a href="#" className="social-icon" aria-label="Facebook">f</a>
              <a href="#" className="social-icon" aria-label="Twitter">t</a>
              <a href="#" className="social-icon" aria-label="LinkedIn">in</a>
              <a href="#" className="social-icon" aria-label="Instagram">ig</a>
            </div>
          </div>
          <div className="footer-links">
            <div className="footer-column">
              <h4 className="footer-column-title">Products</h4>
              <ul>
                {footerLinks.products.map((link, index) => (
                  <li key={index}><a href="#">{link}</a></li>
                ))}
              </ul>
            </div>
            <div className="footer-column">
              <h4 className="footer-column-title">Company</h4>
              <ul>
                {footerLinks.company.map((link, index) => (
                  <li key={index}><a href="#">{link}</a></li>
                ))}
              </ul>
            </div>
            <div className="footer-column">
              <h4 className="footer-column-title">Resources</h4>
              <ul>
                {footerLinks.resources.map((link, index) => (
                  <li key={index}><a href="#">{link}</a></li>
                ))}
              </ul>
            </div>
            <div className="footer-column">
              <h4 className="footer-column-title">Legal</h4>
              <ul>
                {footerLinks.legal.map((link, index) => (
                  <li key={index}><a href="#">{link}</a></li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2024 DesignOps. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

